import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface OrderStatusRequest {
    order_idx: number[];
    order_status: number;
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePutOrderStatus = (
    successCallback?: () => void,
): UseMutationResult<null, AxiosError<ApiErrorResponse>, OrderStatusRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, AxiosError<ApiErrorResponse>, OrderStatusRequest>({
        mutationFn: async ({ order_idx, order_status }: OrderStatusRequest) => {
            try {
                const response = await axios.put(
                    `${enum_api_uri.get_order_status}`,
                    { order_idx, order_status },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    },
                );
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderHistory"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderInfo"] });
            successCallback?.();
        },
    });
};
